import React, { useMemo, useState } from 'react';
import DynamicTable from '@atlaskit/dynamic-table';
import EmptyState from '@atlaskit/empty-state';
import { AuditTrail } from '@css-xp/apd-common';
import { auditTrailEmptyStateProps } from '../../constants/table';
import './audit-trail-table.scss';
import { createTableHead, createTableRows } from './audit-trail-table.utils';

const AuditTrailTable = ({ data = [] }: { data: AuditTrail[] | undefined }) => {
  const [page, setPage] = useState<number>(1);

  const getTableRows = useMemo(() => {
    return createTableRows(data);
  }, [data]);

  return (
    <div className="audit-trail-table">
      <DynamicTable
        head={createTableHead()}
        rows={getTableRows}
        rowsPerPage={5}
        page={page}
        onSetPage={setPage}
        emptyView={<EmptyState {...auditTrailEmptyStateProps} />}
        loadingSpinnerSize="large"
        isLoading={false}
        isFixedSize
        defaultSortKey="date"
        defaultSortOrder="DESC"
        testId="audit-trail-list-table"
      />
    </div>
  );
};

export default AuditTrailTable;
